<template>
  <div>
    <div class="d-flex justify-content-between align-items-center pt-50 mb-2">
      <h2 class="font-weight-bolder m-0">
        Solicitudes
      </h2>
      <b-button variant="primary" @click="showSidebar = true">Solicitar</b-button>
    </div>
    <b-row>
      <b-col lg="4" >
        <b-card class="mb-2">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h5 class="mb-0">Vacaciones restantes</h5>
              <p class="mb-0 display-3"><strong>{{ remainingVacations }}</strong></p>
            </div>
          </div>
        </b-card>
        <b-card>
          <h5>Solicitudes de ausencias</h5>
          <div v-if="items.length === 0" class="text-center py-3">
            <span>No hay solicitudes pendientes.</span>
          </div>
          <div v-else>
            <div class="vacation-cards-list">
              <b-card
                v-for="item in items"
                :key="item.id"
                class="mb-1 vacation-card"
              >
                <div class="d-flex justify-content-between align-items-center mb-1">
                  <span class="fw-bold" v-if="item.type.name !== 'Horas de ausencia'">{{ item.requested_days }} días de {{ item.type.name }}</span>
                  <span class="fw-bold" v-else>{{ item.requested_days }} {{ item.type.name }}</span>
                  <b-badge :variant="statusVariant(item.status)">{{ statusLabel(item.status) }}</b-badge>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="vacation-card-dates">
                    <span class="text-muted">Desde: </span>
                    <span>{{ item.start_date }}</span>
                    <span class="mx-1"></span>
                    <span class="text-muted">Hasta: </span>
                    <span>{{ item.end_date }}</span>
                  </div>
                  <div class="d-flex align-items-center">
                    <span
                      class="d-inline-block px-50 cursor-pointer"
                      :class="item.files && item.files.length > 0 ? 'text-success' : 'text-muted'"
                      :title="item.files && item.files.length > 0 ? 'Ver justificantes' : 'Añadir justificante'"
                      @click="openJustificanteModal(item)"
                    >
                      <feather-icon icon="PaperclipIcon" />
                    </span>
                    <span
                      v-if="canCancelRequest(item)"
                      class="d-inline-block px-50 text-danger cursor-pointer"
                      title="Eliminar solicitud"
                      @click="openCancelModal(item)"
                    >
                      <feather-icon icon="TrashIcon" />
                    </span>
                  </div>
                </div>
              </b-card>
            </div>
          </div>
          <b-modal
            id="cancel-vacation-modal"
            v-model="showCancelModal"
            title="Eliminar solicitud de vacaciones"
            hide-footer
          >
            <div>
              <p>¿Estás seguro de que quieres eliminar esta solicitud de vacaciones?</p>
              <div class="d-flex justify-content-end footerDelete">
                <b-button variant="outline-primary" @click="showCancelModal = false">Cerrar</b-button>
                <b-button variant="danger" class="ml-2" :disabled="cancelLoading" @click="cancelRequest">
                  <span v-if="cancelLoading">Eliminando...</span>
                  <span v-else>Eliminar</span>
                </b-button>
              </div>
            </div>
          </b-modal>
        </b-card>
      </b-col>
      <b-col lg="8">
        <b-card>
          <VacationCalendar :vacation-requests="items" />
        </b-card>
      </b-col>
    </b-row>

    <VacationRequestSidebar
      :visible.sync="showSidebar"
      @submitted="handleRequestSubmitted"
    />

    <absence-document-modal
      v-model="showJustificanteModal"
      :absence-id="justificanteRequest ? justificanteRequest.id : null"
      :files="justificanteRequest ? justificanteRequest.files : []"
      @updated="justificanteRequest = { ...justificanteRequest, files: $event }"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { BBadge, BCard, BButton, BRow, BCol, BModal } from 'bootstrap-vue'
import VacationRequestSidebar from './VacationRequestSidebar.vue'
import VacationCalendar from './VacationCalendar.vue'
import AbsenceDocumentModal from '@/components/absences/AbsenceDocumentModal.vue'

export default {
  components: {
    BRow,
    BCol,
    BBadge,
    BCard,
    BButton,
    BModal,
    VacationRequestSidebar,
    VacationCalendar,
    AbsenceDocumentModal,
  },
  data() {
    return {
      showSidebar: false,
      showCancelModal: false,
      cancelLoading: false,
      showJustificanteModal: false,
      justificanteRequest: null,
    }
  },
  computed: {
    ...mapGetters({
      items: 'absences/getItems',
      user: 'users/getUser',
      authUser: 'auth/getUser',
    }),
    remainingVacations() {
      return this.user?.remaining_vacation_days ?? 0
    },
  },
  async created() {
    this.setItems([])
    await this.getUser(this.authUser.id)
    await this.chargeData()
  },
  methods: {
    ...mapActions({
      list: 'absences/getListAbsences',
      getUser: 'users/getUser',
      delete: 'absences/delete',
    }),
    ...mapMutations({
      setItems: 'absences/setItems',
    }),
    statusVariant(status) {
      switch (status) {
        case 'approved': return 'success'
        case 'pending': return 'warning'
        case 'denied': return 'danger'
        default: return 'secondary'
      }
    },
    statusLabel(status) {
      switch (status) {
        case 'approved': return 'Aprobada'
        case 'pending': return 'Pendiente'
        default: return 'Rechazada'
      }
    },
    handleRequestSubmitted(newRequest) {
      this.vacationRequests.push(newRequest)
      this.showSidebar = false
    },
    async chargeData() {
      await this.list({
        page: 1,
        per_page: 9999,
        type_id: '',
        user_id: this.user.id,
        date_ini: '',
        date_fin: '',
        status: '',
      })
    },
    canCancelRequest(item) {
      const today = new Date()
      const startDate = new Date(item.start_date)
      return (
        (item.status === 'pending' || item.status === 'approved')
        && startDate > today
      )
    },
    openCancelModal(item) {
      this.selectedRequest = item
      this.showCancelModal = true
    },
    async cancelRequest() {
      this.cancelLoading = true
      try {
        await this.delete(this.selectedRequest.id)
        await this.chargeData()
      } finally {
        this.cancelLoading = false
      }
    },
    openJustificanteModal(item) {
      this.justificanteRequest = { ...item, files: [...(item.files || [])] }
      this.showJustificanteModal = true
    },
  },
}
</script>

<style scoped>
.vacation-cards-list {
  display: flex;
  flex-direction: column;
}
.vacation-card {
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  border-radius: 12px;
  border: 1px solid #f0f0f0;
}
.vacation-card-dates {
  font-size: 0.92em;
  color: #666;
}
</style>
